import React from "react";
import PropTypes from "prop-types";

/**
 * ShareProfileButton — the minimal "copy link" share surface for a profile's actions row.
 * Copies the canonical profile URL to the clipboard and confirms it via the shared toast
 * (the same `globalThis.Qwoted.showToast` call shape `ConversationDropdown` already uses).
 * No share-sheet, no per-network icons — one button, one action.
 *
 * @param {Object} props
 * @param {string} props.url - The canonical profile URL to copy
 */
function ShareProfileButton({ url }) {
  const handleClick = async () => {
    await navigator.clipboard.writeText(url);

    globalThis.Qwoted.showToast({
      toastTitle: "Link copied",
      toastBody: "This profile's link is on your clipboard, ready to paste.",
      variant: "success",
    });
  };

  return (
    <button type="button" className="btn btn-outline-primary text-nowrap d-block mb-2 me-2" onClick={handleClick}>
      <i className="fa-regular fa-link me-2" />
      Share Profile
    </button>
  );
}

ShareProfileButton.propTypes = {
  url: PropTypes.string.isRequired,
};

export default ShareProfileButton;
